module.exports = __webpack_public_path__ + "static/img/activity_sdy_08-1.5d92f12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/sydney/images/activity/activity_sdy_08-1.jpg
// module id = ujqL
// module chunks = 0